import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, UserRole } from '@/context/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles?: UserRole[];
}

export default function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && (!user || !allowedRoles.includes(user.role))) {
    if (user?.role === 'admin') {
      return <Navigate to="/admin-dashboard" replace />;
    }

    if (user?.role === 'supervisor') {
      return <Navigate to="/supervisor-dashboard" replace />;
    }

    if (user?.role === 'social_worker') {
      return <Navigate to="/sw-dashboard" replace />;
    }

    if (user?.role === 'victim') {
      return <Navigate to="/v-dashboard" replace />;
    }

    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}